import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CustomAccordion from './CustomAccordion';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function Sidebar({ drawerWidth, open, handleDrawerClose }) {
  const theme = useTheme();

  const accordionData = [
    {
      accordionSummary: '***New Updates***',
      list: [
        { text: '3.55.0', path: '/updates/3.55.0' },
        { text: '3.54.0', path: '/updates/3.54.0' },
        { text: '3.53.0', path: '/updates/3.53.0' }
      ],
    },
    {
      accordionSummary: 'General',
      list: [
        { text: 'Events Summary', path: '/general/events-summary' },
        { text: 'Event Status', path: '/general/event-status' },
        { text: 'Adding New Event', path: '/general/adding-new-event' },
        { text: 'Writing Brief Description', path: '/general/writing-brief-description' },
      ],
    },
    {
      accordionSummary: 'Risk Manager',
      list: [
        { text: 'Assign Reviewers', path: '/risk-manager/assign-reviewers' },
        { text: 'Add/View Comments', path: '/risk-manager/add-view-comments' },
        { text: 'Linked Events', path: '/risk-manager/linked-events' },
        { text: 'Add/View Uploads', path: '/risk-manager/add-view-uploads' },
        { text: 'User Management', path: '/risk-manager/user-management' },
        { text: 'Requesting Approval', path: '/risk-manager/requesting-approval' },
      ],
    },
    {
      accordionSummary: 'Reviewer',
      list: [{ text: 'Complete Review', path: '/reviewer/complete-review' }],
    },
    {
      accordionSummary: 'Approver',
      list: [{ text: 'Approve Events', path: '/approver/approve-events' }],
    },
    {
      accordionSummary: 'Organization Manager',
      list: [
        { text: 'Change Facility', path: '/organization-manager/change-facility' },
        { text: 'Facility Management', path: '/organization-manager/facility-management' },
      ],
    },
    {
      accordionSummary: 'Reports',
      list: [
        { text: 'Dashboard Reports', path: '/reports/dashboard-reports' },
        { text: 'Graphical Reports', path: '/reports/graphical-reports' },
        { text: 'Text Reports', path: '/reports/text-reports' },
      ],
    },
    {
      accordionSummary: 'Password Reset',
      list: [{ text: 'Reset Password', path: '/password-reset' }],
    },
    {
      accordionSummary: 'Settings',
      list: [{ text: 'Settings', path: '/settings' }],
    },
  ];

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: '#500000',
          color: '#fff',
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <DrawerHeader>
        <IconButton onClick={handleDrawerClose} sx={{ color: '#fff' }}>
          {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <>
        {accordionData?.map((accordion, index) => (
          <CustomAccordion key={index} accordionSummary={accordion.accordionSummary} list={accordion.list} />
        ))}
      </>
    </Drawer>
  );
}
